import styled from 'styled-components';

const NavStc = styled.nav`
    height: 50px;
    display: flex;
    font-size: 16px;
    font-weight: 500;
    align-items: center;
    margin-bottom: 1px;
    background-color: #fff;
    box-shadow: 0 1px 0 0 var(--color-border-500);

    .nav {
        display: inline-block;
        > li {
            margin-right: 25px;
            display: inline-block;

            a {
                padding: 15px 0;
                display: inline-block;
                text-decoration: none;
                color: var(--color-body-text-500);

                &.active {
                    color: var(--color-primary-500);
                    border-bottom: ${({ activeBorder }) =>
                        activeBorder && '2px solid var(--color-primary-500)'};
                }
            }
        }
    }

    .navbar--hide {
        display: none;
        @media screen and (min-width: 1024px) {
            display: inline-block;
        }
    }
`;

export default NavStc;
